import { render, staticRenderFns } from "./phonelogin.vue?vue&type=template&id=120820f4&scoped=true"
import script from "./phonelogin.vue?vue&type=script&lang=js"
export * from "./phonelogin.vue?vue&type=script&lang=js"
import style0 from "./phonelogin.vue?vue&type=style&index=0&id=120820f4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120820f4",
  null
  
)

export default component.exports